module.exports = __webpack_public_path__ + "static/media/BIFI-BNB.6834f971.svg";